import script from "./PatientTimeline.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientTimeline.vue?vue&type=script&setup=true&lang=js"

import "./PatientTimeline.vue?vue&type=style&index=0&id=3bdc8c1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bdc8c1a"]])

export default __exports__